var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavicon150X1501(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Favicon_150x150") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Favicon_150x150",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(21.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-499",
    fill: "#F8F7F6",
    points: "53.3707193 149.636811 106.741439 119.501405 107.292367 41.4236608 80.0541526 31.0446297 53.9139425 72.1527588 53.3707193 149.636811"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-500",
    fill: "#E4E4E3",
    points: "53.3780393 149.636811 0.00770529406 119.805765 0.00770529406 39.3663473 53.9139425 72.1527588 53.3780393 149.636811"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-501",
    fill: "#2A90C3",
    points: "27.1106919 7.2463624e-14 -6.18356258e-13 39.5401017 53.9097046 72.3257426 80.0541526 31.0446297 27.1106919 7.2463624e-14"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-502",
    fill: "#1A6C95",
    points: "27.1106919 9.42027112e-14 52.970044 8.38721258 107.292367 41.4236608 80.0541526 31.0446297 27.1106919 9.42027112e-14"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-503",
    fill: "#2A90C3",
    points: "62.2125442 97.3066912 75.8008303 89.4623166 75.8008303 136.822907 62.2125442 144.382185 62.2125442 97.3066912"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-504",
    fill: "#2A90C3",
    points: "84.9123405 85.3557802 97.294748 78.2091199 97.294748 104.187134 84.9123405 111.819227 84.9123405 85.3557802"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-505",
    fill: "#1A6C95",
    points: "45.6615726 96.8559315 33.2830177 89.7054187 33.2830177 115.68767 45.6615726 123.319764 45.6615726 96.8559315"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-506",
    fill: "#1A6C95",
    points: "21.8252454 85.3557802 9.44630525 78.2091199 9.44630525 104.187134 21.8252454 111.819227 21.8252454 85.3557802"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon150X1501);
export default __webpack_public_path__ + "static/media/Favicon_150x150 (1).a504ca33ddc3136684a866711224a418.svg";
export { ForwardRef as ReactComponent };